import _ from 'lodash'
import dayjs from 'dayjs'

export const getHighChartsSeries = (dataset, keys) => {
  if (!dataset) return []
  // Four props are being passed in: homes, which is
  // the list of homes, and dataObject, which can
  // in theory be any array of objects that we want
  // to analyse. In this case it will be todos, but
  // the idea is that it could be careplans, etc.
  // Key is intended to be the key for the data that
  // we want, i.e. todos in this case.
  // expectedNoOfCategories is an integer value that
  // allows us to check that the dataObject is in the
  // correct format.

  /*
    {
        key: ID,
        data: [
            {
                key: '01/2020',
                value: number
            }
        ]
    }
    */
  return keys.map(({ key, label, color }) => {
    return {
      name: label,
      color,
      data: dataset.map((row) => getValue(row.data, key)),
    }
  })
}

const getValue = (data, key) => {
  let row = _.find(data, { key })
  return row ? row.value : 0
}

export const getTableData = (dataset = [], keys = [], maxNameLength) => {
  return dataset.map((row) => {
    let values = keys.map(({ key }) => getValue(row.data, key))
    let keyName = row.keyDoc ? row.keyDoc.name : row.key
    if (maxNameLength) {
      keyName = _.truncate(keyName, { length: maxNameLength })
    }
    return [keyName, ...values]
  })
}

export const getMonths = (from, to) => {
  const months = Math.ceil(to.diff(from, 'month'))
  return _.range(0, months).map((d) => dayjs(from).add(d + 1, 'months'))
}

export const getTotalByKey = (data, keys) => {
  return keys.map((key) => {
    return {
      key,
      value: _.chain(data)
        .map('data')
        .flatten()
        .filter({ key })
        .sumBy('value')
        .value(),
    }
  })
}

export const orderByTotal = (data, sort) => {
  return _.orderBy(data, (row) => {
    let total = _.sumBy(row.data, 'value')
    let sortOrder = sort.order === 'asc' ? 1 : -1
    return (sortOrder * getValue(row.data, sort.key)) / total
  })
}
